import { AppDataContext } from 'context/appData';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'utils/i18n';

const WarningUIElement = ({ uiHandlerRef }) => {
	const { t } = useTranslation('notifications');
	const [warningMessage, setWarningMessage] = useState(null);
	const { configuratorData, errorLoadingConfiguratorData } = useContext(AppDataContext);

	useEffect(() => {
		uiHandlerRef.current?.setUiElement(WarningUIElement, 'warning');
	}, []);

	return (
		<div className="glass_product_warning">
			{errorLoadingConfiguratorData && <p>{t('errorLoadingConfigurationData')}</p>}
			{warningMessage && <p>{warningMessage}</p>}
			{configuratorData?.maintenance_settings?.info?.show_info && (
				<p>{configuratorData.maintenance_settings.info[`info_text_${i18n.language}`]}</p>
			)}
		</div>
	);
};

export default WarningUIElement;
